(function () {
  'use strict';
  function enhanceRecipe() {
    const recipe = window.FREYA_NEW_RECIPE;
    const detail = document.getElementById('recipe-detail');
    if (!recipe || !detail || new URLSearchParams(location.search).get('tarif') !== recipe.slug) return;
    const esc = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[char]);
    const timings = detail.querySelector('.timings');
    const note = document.createElement('p');
    note.className = 'freya-preparation-note';
    note.textContent = recipe.preparationNote;
    timings.before(note);
    const mainMethod = detail.querySelector('.recipe-body > section');
    const secondary = recipe.componentRecipe;
    const section = document.createElement('section');
    section.className = 'freya-gravlaks';
    section.setAttribute('aria-labelledby', 'gravlaks-title');
    section.innerHTML = `<p class="kicker">ÖNCEDEN HAZIRLAYIN</p><h2 id="gravlaks-title">${esc(secondary.title)}</h2><p>${esc(secondary.intro)}</p><dl class="timings">${secondary.times.map(([label,value]) => `<div><dt>${esc(label)}</dt><dd>${esc(value)}</dd></div>`).join('')}</dl><h3>Malzemeler</h3><ul class="ingredient-list">${secondary.ingredients.map(item => `<li><label><input type="checkbox"><span>${esc(item)}</span></label></li>`).join('')}</ul><h3>Hazırlanışı</h3><ol class="steps-list">${secondary.steps.map(step => `<li><span>${esc(step)}</span></li>`).join('')}</ol><aside class="freya-safety-note" aria-labelledby="safety-title"><h3 id="safety-title">Güvenlik notu</h3><p>${esc(recipe.safetyNote)}</p></aside><p class="recipe-signoff">Afiyet olsun.</p>`;
    mainMethod.append(section);
    const productLink = detail.querySelector('.recipe-product a');
    if (productLink) productLink.href = '/products/ubeli-mor-granola';
    const leadPhoto = detail.querySelector('.recipe-lead > img');
    if (leadPhoto) { leadPhoto.width = 1066; leadPhoto.height = 1600; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceRecipe);
  else enhanceRecipe();
})();
